<template lang="pug">
  div(:class="b()")
    .space-bottom  COTIZAMOS CON LAS PRINCIPALES ENTIDADES DEL PAÍS.
    .logos
      figure.logo(v-for="logo in logos" :key="logo.src")
        img(:src="logo.src")
</template>

<script>
  export default {
    name: 'trust-banks',

    data() {
      return {
        logos: [
          { src: this.$cloudfrontURL('/logos/santander.svg') },
          { src: this.$cloudfrontURL('/logos/bx.svg') },
          { src: this.$cloudfrontURL('/logos/scotiabank.svg') },
          { src: this.$cloudfrontURL('/logos/banregio.svg') },
          { src: this.$cloudfrontURL('/logos/citibanamex.svg') },
          { src: this.$cloudfrontURL('/logos/banorte.svg') },
          { src: this.$cloudfrontURL('/logos/afirme.svg') },
          { src: this.$cloudfrontURL('/logos/hsbc.svg') },
          { src: this.$cloudfrontURL('/logos/smartlending.svg') },
          { src: this.$cloudfrontURL('/logos/tucasaexpress.svg') },
        ],
      };
    },
  };
</script>